<template>
	<v-card tile elevation="0" style="height: 100%; overflow-y: hidden">
		<v-card-title class="text-left card-header fixed-card-title2">
			<v-row no-gutters>
				<v-col cols="6">
					<v-toolbar-title>{{ $t('edit-care-plan-header') }}</v-toolbar-title>
				</v-col>
				<v-spacer />
				<v-icon @click="closeDrawer" class="white-icon">mdi-close</v-icon>
			</v-row>
		</v-card-title>
		<v-card-text class="pt-4 pb-0 overflow-y-auto" style="height: calc(100vh - 221px)">
			<v-row dense class="ma-0">
				<v-col cols="12">
					<v-select
						:label="$t('status')"
						v-model="selectedStatus"
						:items="carePlanStatusTemplate"
						item-text="status"
						outlined
						hide-details
						:menu-props="{ maxHeight: 199, offsetY: true }">
						<template v-slot:item="{ item }">
							<v-tooltip left>
								<template v-slot:activator="{ on, attrs }">
									<span v-bind="attrs" v-on="on" style="width: 100%">
										{{ item.status }}
									</span>
								</template>
								{{ item.description }}
							</v-tooltip>
						</template>
					</v-select>
				</v-col>
			</v-row>
			<v-row dense class="ma-0">
				<v-col cols="12">
					<v-select
						:label="$t('type')"
						v-model="selectedType"
						:items="carePlanTypeTemplate"
						item-text="typeName"
						outlined
						hide-details
						:menu-props="{ maxHeight: 199, offsetY: true }">
						<template v-slot:item="{ item }">
							<v-tooltip left>
								<template v-slot:activator="{ on, attrs }">
									<span v-bind="attrs" v-on="on" style="width: 100%">
										{{ item.typeName }}
									</span>
								</template>
								{{ item.description }}
							</v-tooltip>
						</template>
					</v-select>
				</v-col>
			</v-row>
			<v-row dense class="ma-0">
				<v-col cols="12">
					<v-textarea
						v-model="description"
						:label="$t('description')"
						:inputLabel="$t('time-spent')"
						outlined
						hide-details
						rows="12" />
				</v-col>
			</v-row>
		</v-card-text>
		<v-container class="px-4">
			<v-row dense class="ma-0">
				<v-col cols="12">
					<InputTimeFormatter :inputValue="timeSpent" @update:inputValue="(val) => (timeSpent = val)" :dense="false" />
				</v-col>
			</v-row>
			<v-row dense class="ma-0">
				<v-col cols="6" order="1">
					<v-btn @click="closeDrawer()" color="secondary" style="color: black" block>
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-tooltip top v-if="!editButtonEnabled">
					<template v-slot:activator="{ on, attrs }">
						<v-col cols="6" v-bind="attrs" v-on="on" order="2">
							<v-btn disabled block>{{ $t('update') }}</v-btn>
						</v-col>
					</template>
					<span>{{ $t('fill-all-fields-warning') }}</span>
				</v-tooltip>
				<v-col cols="6" v-else order="2">
					<v-btn @click="updateCarePlan()" color="dark_purple" style="color: white" block>
						{{ $t('update') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import InputTimeFormatter from '../Client/components/InputTimeFormatter.vue';

export default {
	name: 'CCMCarePlanEdit',
	data () {
		return {
			description: '',
			selectedStatus: null,
			selectedType: null,
			timeSpent: 0,
			carePlanStatusTemplate: null,
			carePlanTypeTemplate: null,
		};
	},
	computed: {
		...mapState({
			currentCarePlan: (state) => state.ccmCarePlans.ccmCarePlan,
			currentRecord: (state) => state.ccmRecords.ccmRecord,
			userData: (state) => state.authentication.userData,
		}),
		editButtonEnabled () {
			return this.description.length > 0 && this.timeSpent && this.timeSpent <= 7200;
		},
	},
	methods: {
		...mapActions({
			updateCCMCarePlan: 'ccmCarePlans/updateCCMCarePlan',
			getAllCarePlanStatuses: 'ccmRecords/getAllCarePlanStatuses',
			getAllCarePlanTypes: 'ccmRecords/getAllCarePlanTypes',
		}),
		async updateCarePlan () {
			const request = {
				id: this.currentCarePlan.id,
				body: {
					ccmRecordId: this.currentCarePlan.ccmRecordId,
					patientId: this.currentCarePlan.patientId,
					hospitalId: this.currentCarePlan.hospitalId,
					carePlanStatus: this.selectedStatus,
					date: new Date().toISOString(),
					type: this.selectedType,
					description: this.description,
					timeSpentSeconds: parseInt(this.timeSpent),
					staffId: this.currentCarePlan.staffId,
					performedBy: this.currentCarePlan.performedBy,
					performedByRole: this.currentCarePlan.performedByRole,
					additionalData: this.currentCarePlan.additionalData ?? '',
				},
			};
			await this.updateCCMCarePlan(request);
			this.closeDrawer();
		},
		closeDrawer () {
			this.timeSpent = 0;
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', false);
			this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
		},
	},
	async mounted () {
		this.description = this.currentCarePlan.description;
		this.selectedStatus = this.currentCarePlan.carePlanStatus;
		this.selectedType = this.currentCarePlan.type;
		if (!this.carePlanStatusTemplate) {
			const response = await this.getAllCarePlanStatuses();
			this.carePlanStatusTemplate = response.data;
		}
		if (!this.carePlanTypeTemplate) {
			const response = await this.getAllCarePlanTypes();
			this.carePlanTypeTemplate = response.data;
		}
	},
	watch: {
		currentCarePlan () {
			this.description = this.currentCarePlan.description;
			this.selectedStatus = this.currentCarePlan.carePlanStatus;
			this.selectedType = this.currentCarePlan.type;
		},
	},
	components: { InputTimeFormatter },
};
</script>
